function a(d) {
  return d === "standard" ? {
    paddingX: "24",
    paddingY: "12"
  } : {
    paddingX: "xlarge",
    paddingY: "small"
  };
}
export {
  a as default
};
